
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/addPanelInfra/newAddPanel/sectionView.scss.css.virtualfile';
        module.exports = {"sectionView":"_sectionView_aff3l_1"};